import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { ContentLayoutComponent } from './';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './directives';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    ContentLayoutComponent,
    HeaderComponent,
    SidebarComponent,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES
  ],
  exports: [

  ]
})
export class LayoutModule {}


